import React from 'react'

function nopage() {
  return (
    <div>nopage</div>
  )
}

export default nopage